<template>
  <m-form :showList="false"
          :show-creation-data="false"
          :show-list-btn="false"
          :show-clear-btn="false"
          :canEdit="false"
          :show-navigation-btns="false"
          ref="factorForm"
  >
    <template>
      <v-card class="rounded-lg lightSecondary">
        <v-card-title class="white--text">
          <v-img class="ml-5" src="/img/icons/factor_dark.svg" max-width="30"></v-img>
          جزئیات پرداخت

          <v-spacer></v-spacer>
          <template v-if="item.id">
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    :href="endpoint(`subscriptions/factorDetail/html?id=${item.id}&token=${token}`)"
                    target="_blank"
                    icon
                    v-bind="attrs"
                    v-on="on"
                    depressed
                    class="secondary--text secondary pa-3"
                >
                  <v-img max-height="20" max-width="20" src="/img/icons/dark_print_icon.svg" />
                </v-btn>
              </template>
              چاپ فاکتور
            </v-tooltip>
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    :href="endpoint(`subscriptions/factorDetail/pdf?id=${item.id}&token=${token}`)"
                    target="_blank"
                    icon
                    v-bind="attrs"
                    v-on="on"
                    depressed
                    class="secondary--text secondary pa-3"
                >
                  <v-img max-height="20" max-width="20" src="/img/icons/dark_pdf.svg" />
                </v-btn>
              </template>
              خروجی PDF
            </v-tooltip>
          </template>
          <v-tooltip top color="secondary">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  class="secondary white--text mr-6 mt-1 mt-md-0 pa-4"
                  @click="$router.push({name:'SubscriptionFactorsList'})"
                  icon
              >
                <v-img max-height="25" max-width="25" src="/img/icons/list_icon.svg"></v-img>
              </v-btn>
            </template>
             لیست پرداخت ها
          </v-tooltip>

        </v-card-title>

      </v-card>
      <v-card class="rounded-b-lg mr-5 ml-5 secondary">
        <v-row class="mt-2 mb-2">
          <v-col cols="12" md="2" class="text-center">
            <span class="white--text">شماره فاکتور: </span>
            <span class="firstColor--text mr-2"> {{ item.id }}</span>
          </v-col>
          <v-col cols="12" md="2" class="text-center">
            <span class="white--text">خریدار: </span>
            <span class="firstColor--text mr-2"> {{ item.created_by }}</span>
          </v-col>
          <v-col cols="12" md="2" class="text-center">
            <span class="white--text">نام کسب و کار: </span>
            <span v-if="item.business_name" class="firstColor--text mr-2"> {{ item.business_name }}</span>
          </v-col>

          <v-col cols="12" md="3" class="text-center">
            <span class="white--text">تاریخ و ساعت: </span>
            <span class="firstColor--text mr-2"> {{ item.created_at }}</span>
          </v-col>
        </v-row>
      </v-card>
      <v-simple-table class="mr-7 ml-7 rounded-b-lg">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-center">
              نوع
            </th>
            <th class="text-center">
              عنوان
            </th>
            <th class="text-center">
              مبلغ
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="row in item.items">
            <td class="text-center">{{ row.type_display }}</td>
            <td class="text-center">{{ row.affiliate_factor_title }}</td>
            <td class="text-center">{{ row.amount | toMoney }}</td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <template>
      <v-row>
        <v-col cols="9" class="float-left mt-16 pr-7" v-if="!isXs">
          <v-img max-width="350" src="/img/icons/exuni.png" />
        </v-col>
        <v-col :cols="isXs?12:3">
          <v-simple-table :class="isXs?'mt-3':'ml-7 mt-7'">
            <template v-slot:default>
              <tbody>
              <tr>
                <td class="text-right">جمع :</td>
                <td class="text-center"><span class="secondary--text "> {{ sum | toMoney }} </span></td>
              </tr>
              <tr>
                <td class="text-right">تخفیف :</td>
                <td class="text-center">
                  <span class="success--text"> {{ item.discount_amount | toMoney(0) }}</span>
                </td>
              </tr>
              <tr>
                <td class="text-right">مبلغ فاکتور بعد از تخفیف :</td>
                <td class="text-center">
                  <span class="secondary--text"> {{ sum - item.discount_amount | toMoney(0) }}</span>
                </td>
              </tr>
              <tr>
                <td class="text-right">مالیات بر ارزش افزوده :</td>
                <td class="text-center"><span class="secondary--text "> {{ tax | toMoney }} </span></td>
              </tr>
              <tr>
                <td class="text-right">مبلغ کل فاکتور :</td>
                <td class="text-center"><span class="secondary--text "> {{ sumWithTax | toMoney }} </span></td>
              </tr>

              </tbody>
            </template>
          </v-simple-table>

        </v-col>
      </v-row>
    </template>
  </m-form>
</template>

<script>
import {MFormMixin} from "@/components/m-form";
import GetUserApi from "@/views/panel/user/getUserApi.js";
import SubscriptionMixin from "./mixin";

export default {
  name: "SubscriptionFactorDetail",
  mixins: [MFormMixin, SubscriptionMixin, GetUserApi],
  props: {
    id: {},
  },
  data() {
    return {
      baseUrl: "subscriptions/factor",
      appendSlash: false,
      hasList: false,
      paymentDialog: false,
    };
  },
  computed: {
    sum() {
      let sum = 0;
      if (this.rows.length) {
        this.rows.forEach((row) => {
          if (row.id) sum += Number(row.amount);
        });
      }
      return sum;
    },
    tax() {
      return (this.sum - this.item.discount_amount) / 100 * 9;
    },
    sumWithTax() {
      return this.sum - this.item.discount_amount + this.tax;
    },
  },
  mounted() {
    const route = this.$route;
    if (route.query.success == "true") {
      this.successNotify();
      this.$router.push({
        name: route.name,
        params: route.params,
      });
    }
  },
  methods: {
    setItem(item) {
      this.item = item;
      this.rows = this.copy(this.item.items);
    },
  },
};
</script>

<style scoped lang="scss"></style>
